/**
 * Generated runtime TestId mirror for frontend/src/components/language-switcher.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const LanguageSwitcherTestIds = {
  btnLanguageSwitcher: "btn-language-switcher",
  btnLanguage: (locale: string) => `btn-language-${locale}`,
  btnLanguagePrefix: () => "btn-language-" as TestIdPrefix
} as const;
